<rwidget-swish-loading></rwidget-swish-loading>
<rwidget-navigate-away-modal
    [showNavigationModal]="showNavigationModal"
    (onConfirmNavigation)="onConfirmNavigationModal()"
    (onCancelNavigation)="onCloseNavigationModal()"></rwidget-navigate-away-modal>
